<script setup lang="ts">
const props = defineProps<{
  img: string
  title: string
  description: string
  link: string,
  buttonText: string
}>()

const {
  img,
  title,
  description,
  link,
  buttonText
} = toRefs(props)
</script>

<template>
  <div>
    <article class="carticle carticle--large carticle--v2">
      <div class="carticle__img-container carticle__img-container--v2">
        <img :src="img" :alt="title" width="420" height="249">
      </div>
      <div class="carticle__text-container carticle__text-container--v2">
        <div>
          <div class="carticle__title">{{ title }}</div>
        <div class="carticle__text" v-html="description"/>
      </div>
      <a :href="link" class="carticle__button cbtn cbtn--medium cbtn--dark">
        {{ buttonText }}
      </a>
    </div>
    </article>
  </div>
</template>
